export default function VoiceAndVideoTab() {
    return (
        <h2>Voice & Video</h2>
    );
}